import React from 'react'
import { Menu, Sticky } from 'semantic-ui-react'
import {
  TabCounts,
  UserTaxCalculationTabNames,
} from '../userTaxCalculation.slice'

interface Props {
  activeTab: UserTaxCalculationTabNames
  counts: TabCounts
  contextRef: React.RefObject<HTMLElement>
  onTabChange: (_tabName: UserTaxCalculationTabNames) => void
}

const CalculationTabMenu: React.FC<Props> = ({
  counts,
  contextRef,
  onTabChange,
  activeTab,
}) => {
  return (
    <Sticky offset={0} context={contextRef}>
      <Menu id="qteCalculationTabMenu" pointing secondary>
        <Menu.Item
          name={`${UserTaxCalculationTabNames.all} (${counts.all})`}
          active={activeTab === UserTaxCalculationTabNames.all}
          onClick={() => onTabChange(UserTaxCalculationTabNames.all)}
        />
        <Menu.Item
          name={`${UserTaxCalculationTabNames.singleState} (${counts.singleState})`}
          active={activeTab === UserTaxCalculationTabNames.singleState}
          onClick={() => onTabChange(UserTaxCalculationTabNames.singleState)}
        />
        <Menu.Item
          name={`${UserTaxCalculationTabNames.multiState} (${counts.multiState})`}
          active={activeTab === UserTaxCalculationTabNames.multiState}
          onClick={() => onTabChange(UserTaxCalculationTabNames.multiState)}
        />
        <Menu.Item
          name={`${UserTaxCalculationTabNames.edgeCases} (${counts.edgeCases})`}
          active={activeTab === UserTaxCalculationTabNames.edgeCases}
          onClick={() => onTabChange(UserTaxCalculationTabNames.edgeCases)}
        />
      </Menu>
    </Sticky>
  )
}

export default CalculationTabMenu
